<div class="overview">
    <div
        *ngFor="let section of data"
        class="overview__section">
        <div class="overview__section__header">
            <span>{{ section.title | translate }}</span>
            <sera-ri-value
                [size]="'medium'"
                [label]="'PAGE.ANALYSIS.CRITERION_SHI.LBL' | translate"
                [value]="section.riskValue"
                [color]="section.riskColor"></sera-ri-value>
        </div>
        <div class="overview__section__content">
            <div
                *ngFor="let item of section.items"
                class="overview__section__content__item">
                <div
                    [class]="'overview__section__content__item__wrapper'"
                    (click)="navigateToCriterion(convertCriterionIdToNumber(item.id))"
                    (keydown)="navigateToCriterion(convertCriterionIdToNumber(item.id))">
                    <img
                        src="{{ item.icon }}"
                        [alt]="item.title | translate" />
                    <div class="overview__section__content__item__wrapper__label">
                        <span class="overview__section__content__item__wrapper__label__criterion">{{ item.title | translate }}</span>
                        <span class="overview__section__content__item__wrapper__label__description">{{ item.description | translate }}</span>
                    </div>
                </div>
                <div
                    class="overview__section__content__item__toggles"
                    [ngClass]="{ overview__section__content__item__toggles__cr13: item.id === 'CR13' }">
                    <div
                        class="overview__section__content__item__toggle"
                        *ngIf="item.hasNoStressToggle">
                        <ds-switch
                            [ngModel]="item.noStress ?? false"
                            size="md"
                            [readonly]="!readonly"
                            [disabled]="!item.noStressEnabled"
                            (ngModelChange)="onStressToggleChange(item.id, $event)"
                            >{{
                                item.id === 'CR11'
                                    ? ('PAGE.MM11.WITHOUT_CYCLE.LBL' | translate)
                                    : item.id === 'CR13'
                                    ? ('PAGE.ANALYSIS.CRITERION_NO_HAZARD.LBL' | translate)
                                    : ('PAGE.ANALYSIS.CRITERION_NO_STRESS.LBL' | translate)
                            }}</ds-switch
                        >
                    </div>
                    <div
                        class="overview__section__content__item__show-hazards"
                        *ngIf="item.id === 'CR13'">
                        <ds-toggle-button
                            [checked]="showCR13Hazards"
                            (click)="!((item.noStress ?? false) || (isLoadingAnalysis ?? false)) && onShowHazardsToggle()"
                            (keydown)="!((item.noStress ?? false) || (isLoadingAnalysis ?? false)) && onShowHazardsToggle()"
                            [disabled]="(item.noStress ?? false) || (isLoadingAnalysis ?? false)"
                            size="md"
                            icon="eye">
                            {{ 'PAGE.OVERVIEW.HAZARDS.LBL' | translate }}
                        </ds-toggle-button>
                    </div>
                </div>
                <sera-ri-value
                    *ngIf="item.id !== 'CR13'"
                    [withLabel]="false"
                    [size]="'medium'"
                    [value]="item.riskValue"
                    [color]="item.riskColor"></sera-ri-value>
            </div>
            <div
                *ngIf="showCR13Hazards && allHazards && allHazards.length > 0 && section.title === 'PAGE.OVERVIEW.ACCIDENTS.LBL' && !getCR13NoStressStatus()"
                class="overview__section__content__hazards">
                <div
                    *ngFor="let hazard of allHazards; let i = index"
                    class="overview__section__content__item">
                    <div [class]="'overview__section__content__item__wrapper'">
                        <img
                            loading="lazy"
                            [src]="'assets/images/MM13/g' + (i + 1) + '.gif'"
                            [alt]="'Hazard group ' + (i + 1)"
                            class="hazard-icon" />
                        <div class="overview__section__content__item__wrapper__label">
                            <span class="overview__section__content__item__wrapper__label__criterion">{{ hazard.translatedName || 'Hazard ' + (i + 1) }}</span>
                        </div>
                    </div>
                    <sera-ri-value
                        [label]="'PAGE.ANALYSIS.CRITERION_RZ.LBL' | translate"
                        [size]="'medium'"
                        [value]="(getDataMM13MainElement(hazard.id) | async)?.rzValue"
                        [color]="(getDataMM13MainElement(hazard.id) | async)?.color">
                    </sera-ri-value>
                </div>
            </div>
        </div>
    </div>
</div>
